import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from "@angular/core";
import {VisitPlanFacadeService} from "../../services/visit-plan-facade.service";
import {VisitScheduleAgentImportOptionModel} from "../../../models/visit-schedule-agent-import-option.model";
import {Subscription} from "rxjs";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";

require('./visit-plan-external-agents-resource-holders-single-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-external-agents-resource-holders-single-select-list',
  templateUrl: './visit-plan-external-agents-resource-holders-single-select-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanExternalAgentsResourceHoldersSingleSelectList implements OnInit, OnChanges, OnDestroy {

  @Input() visitPlanId: string;
  @Input() visitScheduleId: string;
  @Input() selectedAgentId: string;
  @Input() queryString?: string = '';
  @Input() hideSearch?: boolean = false;

  @Output() onSelect = new EventEmitter<VisitScheduleAgentImportOptionModel>();

  @ViewChild(CdkVirtualScrollViewport) private viewport: CdkVirtualScrollViewport;

  public options: VisitScheduleAgentImportOptionModel[] = [];
  public optionsToDisplay: VisitScheduleAgentImportOptionModel[] = [];
  public isLoading: boolean = false;
  public cursor: string | undefined;

  private sub: Subscription;

  constructor(
    @Inject(VisitPlanFacadeService) private visitPlanFacadeService: VisitPlanFacadeService,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this._getAgents();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this._getAgents(true);
    }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  onQueryChange(query: string) {
    this.queryString = query;
    this._getAgents(true);
  }

  onSelectAgent(option: VisitScheduleAgentImportOptionModel) {
    this.selectedAgentId = option.id;
    this.onSelect.emit(option);
  }

  getNextBatch() {
    if (this.isLoading || !this.cursor) return;
    if (this.viewport.measureScrollOffset('bottom') < 50) {
      this._getAgents();
    }
  }

  private _getAgents(reset: boolean = false) {
    if (reset) {
      this.cursor = undefined;
      this.options = [];
      this.optionsToDisplay = [];
    }

    this.isLoading = true;
    this.cdr.detectChanges();

    const params: any = {
      limit: 100
    };

    if (this.cursor) {
      params.cursor = this.cursor;
    }

    if (this.queryString) {
      params.query = this.queryString;
    }

    this.sub?.unsubscribe();
    this.sub = this.visitPlanFacadeService.getExternalAgentsResourceHoldersCursor(this.visitPlanId, this.visitScheduleId, params)
      .subscribe({
        next: (res) => {
          this.options = [...this.options, ...res.list];
          this.optionsToDisplay = [...this.options];
          this.cursor = res.cursor;
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }
}
